import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAnalyzerCriterionEntity } from './conversation-analyzer-criterion.entity';

export interface AnalyzerConfig {
	maxScore?: number;
	passingScore?: number;
}

@Entity('_conversation_analyzer')
export class ConversationAnalyzerEntity extends BaseEntity {
	@Column({ name: 'name', type: 'varchar', length: 100, nullable: false })
	public name!: string;

	@Column({ name: 'description', type: 'text', nullable: true })
	public description?: string;

	@Column({ name: 'is_active', type: 'tinyint', width: 1, default: 1 })
	public isActive!: boolean;

	@Column({
		name: 'llm_provider',
		type: 'varchar',
		length: 50,
		default: "'claude'",
	})
	public llmProvider!: string;

	@Column({ name: 'llm_model', type: 'varchar', length: 100, nullable: true })
	public llmModel?: string;

	@Column({ name: 'config', type: 'json', nullable: true })
	public config?: AnalyzerConfig;

	@OneToMany(() => ConversationAnalyzerCriterionEntity, (c) => c.analyzer)
	public criteria?: Array<ConversationAnalyzerCriterionEntity>;
}
